import { Grid, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import React from "react";

interface TimeSlotGridProps {
    timeSlots: React.ReactNode[];
}
const TimeSlotGrid = ({ timeSlots }: TimeSlotGridProps) => {
    return (
        <Grid
            templateColumns="repeat(4, minmax(0, 1fr))"
            gap={ThemeSpaceVariable.Small}
            mt={ThemeSpaceVariable.Small}
        >
            {timeSlots}
        </Grid>
    );
};

export default TimeSlotGrid;
